import request from '@/request'
import type { LoginParams, LoginPayload, MyPermissions, UserInfo } from './types'

/** POST /auth/login */
export const loginApi = (data: LoginParams) =>
  request.post<LoginPayload>({ url: '/auth/login', data })

/** POST /auth/logout */
export const logoutApi = () => request.post<null>({ url: '/auth/logout' })

/** GET /auth/me */
export const getMeApi = () => request.get<UserInfo>({ url: '/auth/me' })

/** GET /auth/me/permissions */
export const getMyPermissionsApi = () =>
  request.get<MyPermissions>({ url: '/auth/me/permissions' })